import { ApolloLink } from 'apollo-link'
import { getJwtToken } from '@edge/spark/io-aws'
import { AuthOptions, AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link'
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link'

const unifiedGraphqlEndpoint = process.env['REACT_APP_UNIFIED_GRAPHQL_URI']

if (!unifiedGraphqlEndpoint) {
    console.error('Unified Environment variables not defined')
}

const auth: AuthOptions = {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: () => getJwtToken(),
}

export const unifiedLink = unifiedGraphqlEndpoint
    ? ApolloLink.from([
          // @ts-expect-error why?
          createAuthLink({
              url: unifiedGraphqlEndpoint,
              auth,
          }),
          // @ts-expect-error why?
          createSubscriptionHandshakeLink({ url: unifiedGraphqlEndpoint, auth }),
      ])
    : ApolloLink.from([])
